<template>
  <div class="text-center">
    <NotFoundImage class="w-6/12 m-auto" />
    <h1>We Couldn't Connect the Dots</h1>
    <p>We're sorry, the page you were trying to retrieve could not be found.</p>
    <p>
      Please use your browser's back button to go to the previous page<br />or
      <a href="/">straight to the dashboard</a>.
    </p>
  </div>
</template>

<script setup lang="ts">
import NotFoundImage from "@/images/404_dots.svg?component";
</script>

<style scoped></style>
